import React, { useState } from "react";
import {
  Grid,
  Typography,
  Box,
  Card,
  CardMedia,
  Pagination,
} from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";

const newsData = [
  {
    id: 1,
    title: "Karnataka SSLC 2026 Syllabus Updated",
    date: "Jan 10, 2026",
    description:
      "Karnataka SSLC board releases updated syllabus for 2026 examinations.",
    image:
      "https://images.pexels.com/photos/5212345/pexels-photo-5212345.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 2,
    title: "PUC Exam Dates Announced",
    date: "Jan 9, 2026",
    description:
      "Karnataka PUC exams for March 2026 have been officially scheduled.",
    image:
      "https://images.pexels.com/photos/256417/pexels-photo-256417.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 3,
    title: "Karnataka CET 2026 Registration Open",
    date: "Jan 8, 2026",
    description:
      "Students can now apply online for Karnataka CET 2026 entrance exam.",
    image:
      "https://images.pexels.com/photos/3184325/pexels-photo-3184325.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 4,
    title: "Karnataka Diploma Exams Schedule",
    date: "Jan 7, 2026",
    description:
      "Diploma board releases official timetable for 2026 examinations.",
    image:
      "https://images.pexels.com/photos/4145191/pexels-photo-4145191.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 5,
    title: "VTU 2026 Exam Updates",
    date: "Jan 6, 2026",
    description:
      "VTU announces exam guidelines and evaluation updates for 2026.",
    image:
      "https://images.pexels.com/photos/267885/pexels-photo-267885.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 6,
    title: "Karnataka Scholarship 2026",
    date: "Jan 5, 2026",
    description:
      "Latest scholarship notifications for UG & PG students in Karnataka.",
    image:
      "https://images.pexels.com/photos/4386373/pexels-photo-4386373.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 7,
    title: "Karnataka Board Revaluation Dates",
    date: "Jan 4, 2026",
    description:
      "SSLC and PUC revaluation and photocopy application dates released.",
    image:
      "https://images.pexels.com/photos/3771074/pexels-photo-3771074.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
  {
    id: 8,
    title: "Online Learning Tips for Students",
    date: "Jan 3, 2026",
    description:
      "Effective tips for students to improve learning using online tools.",
    image:
      "https://images.pexels.com/photos/4145193/pexels-photo-4145193.jpeg?auto=compress&cs=tinysrgb&w=600",
  },
];

export default function News() {
  const [page, setPage] = useState(1);

  const itemsPerPage = 6;
  const totalPages = Math.ceil(newsData.length / itemsPerPage);

  const displayedNews = newsData.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  return (
    <>
      <Header />

      <Box sx={{ px: { xs: 2, md: 12 }, py: { xs: 4, md: 8 } }}>
        {/* Heading */}
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          sx={{
            color: "#1A4B83",
            fontSize: { xs: 24, md: 36 },
            borderBottom: "4px solid #1A4B83",
            width: "fit-content",
            mx: "auto",
            pb: 1,
            mb: 6,
          }}
        >
          Latest Education News
        </Typography>

        {/* News Cards */}
        <Grid container spacing={5}>
          {displayedNews.map((news) => (
            <Grid size={{ xs: 12, md: 4, sm: 6 }} key={news.id}>
              <Card
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  boxShadow: 6,
                  transition: "0.3s",
                  "&:hover": {
                    boxShadow: 12,
                    transform: "translateY(-6px)",
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="220"
                  image={news.image}
                  alt={news.title}
                />

                <Box sx={{ p: 2.5 }}>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: { xs: 16, md: 18 },
                      mb: 1,
                      color: "#1E293B",
                    }}
                  >
                    {news.title}
                  </Typography>

                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 2, lineHeight: 1.6 }}
                  >
                    {news.description}
                  </Typography>

                  <Typography
                    variant="caption"
                    sx={{
                      display: "inline-block",
                      px: 1.5,
                      py: 0.5,
                      borderRadius: 2,
                      bgcolor: "rgba(26,75,131,0.1)",
                      color: "#1A4B83",
                      fontWeight: 500,
                    }}
                  >
                    {news.date}
                  </Typography>
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* Pagination */}
        {totalPages > 1 && (
          <Box display="flex" justifyContent="center" mt={6}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={(e, value) => setPage(value)}
              color="primary"
              size="large"
            />
          </Box>
        )}
      </Box>

      <Footer />
    </>
  );
}

